export default "__VITE_ASSET__4e1c2950__"